import React from 'react';
import logoCompleto from '../assets/Olho -Lupa Data.png'; // Importa a logo SVG

// Componente Hero da página inicial
const Hero: React.FC = () => {
  return (
    // Aplicando o mesmo gradiente da IAPage
    <div className="relative bg-gradient-to-r from-lupa-orange to-lupa-yellow overflow-hidden">
      {/* Overlay de gradiente para melhorar legibilidade do texto */}
      <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
      
      {/* Padrão de fundo com elementos de dados e IA */}
      <div className="absolute inset-0 opacity-20 z-0">
        <div className="absolute inset-0" style={{ 
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 relative z-20">
        <div className="md:flex md:items-center md:justify-between">
          <div className="md:w-1/2 animate-fade-in">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
              Tenha uma customização para o seu fluxo de dados que atenda a necessidade da sua empresa.
            </h1>
            <p className="mt-6 text-xl text-white/90 max-w-3xl">
              <span className="font-bold text-2xl block mb-2">Desvende o potencial oculto em seus dados.</span> 
              Com a Lupa Data, <span className="italic font-medium">você enxerga além do óbvio</span>, permitindo que seus dados 
              revelem insights valiosos que estavam invisíveis aos olhos.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a href="#contato" className="btn-primary text-center">
                Fale Conosco
              </a>
              <a href="#solucoes" className="btn-secondary text-center">
                Saiba Mais
              </a>
            </div>
          </div>
          {/* Seção da direita atualizada para mostrar a logo */}
          <div className="hidden md:block md:w-1/2 animate-slide-up flex items-center justify-center p-8">
            <img src={logoCompleto} alt="Lupa Data Logo" className="h-auto w-full max-w-lg object-contain" />
          </div>
        </div>
      </div>
      
      {/* Curva decorativa na parte inferior */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
          <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default Hero;

